import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/core/_config/app.config';

@Injectable({
    providedIn: 'root',
})
export class FileDevolutionService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig) {}

    getServicesGroup(): Observable<any> {
        return this.http.get(`${this.API_URL}Services/ServiceGroup`);
    }

    getLegalEntityDevolutionFromFile(responsibleId: string, entityId: string): Observable<any> {
        return this.http.get(
            `${this.API_URL}LegalEntity/GetLegalEntityDevolutionFromFile?responsibleId=${responsibleId}&entityFile=${entityId}`,
        );
    }
}
